import {
  Card, Col, Flex, Row, Spin, Statistic,
} from 'antd';
import Layout from 'components/Layout';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchPlatformReportingOverview } from 'api/platform';
import { captureException } from 'utils/errors';

function PlatformReporting() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPlatformReportingOverview()
      .then(setData)
      .catch(captureException)
      .finally(() => setLoading(false));
  }, []);

  const go = (params) => {
    const qs = new URLSearchParams(params).toString();
    navigate(`/platform/clients?${qs}`);
  };

  if (loading || !data) {
    return (
      <Layout header={<Layout.Header title="Reporting" loading />}>
        <Flex justify="center" style={{ padding: 48 }}>
          <Spin size="large" />
        </Flex>
      </Layout>
    );
  }

  const cards = [
    { title: 'Total clients', value: data.total, onClick: () => go({}) },
    { title: 'Active', value: data.active, onClick: () => go({ is_active: 'true' }) },
    { title: 'Inactive', value: data.inactive, onClick: () => go({ is_active: 'false' }) },
    { title: 'Suspended', value: data.suspended, onClick: () => go({ is_suspended: 'true' }) },
    {
      title: 'Missing billing plan',
      value: data.missing_billing_plan,
      onClick: () => go({ missing_billing_plan: 'true' }),
    },
    {
      title: 'Missing SMS client',
      value: data.missing_sms_client,
      onClick: () => go({ missing_sms_client: 'true' }),
    },
    {
      title: 'Overdue unpaid invoices',
      value: data.with_overdue_unpaid_invoices,
      onClick: () => go({ with_overdue_unpaid_invoices: 'true' }),
    },
    {
      title: 'Missing payment method',
      value: data.missing_payment_method,
      onClick: () => go({ missing_payment_method: 'true' }),
    },
  ];

  return (
    <Layout header={<Layout.Header title="Reporting" />}>
      <Row gutter={[12, 12]}>
        {cards.map((card) => (
          <Col key={card.title} xs={24} sm={12} md={8} lg={6}>
            <Card
              hoverable
              size="small"
              onClick={card.onClick}
              styles={{ body: { padding: '16px 20px' } }}
            >
              <Statistic title={card.title} value={card.value} />
            </Card>
          </Col>
        ))}
      </Row>
    </Layout>
  );
}

export default PlatformReporting;
